import {CommentTextInput, CancelConfirmPanel, LoadingSpinner} from "thrive-components";
import { ICommentInputPanelProps } from "@/interfaces/activityFeed";
import UseCommentInputPanel from "./CommentInputPanel.hooks";



const CommentInputPanel = ({onPostCommentClick, commentString, className, setCommentString, showCommentFunctionality, setShowCommentFunctionality, profileImageUrl, isPosting}: ICommentInputPanelProps) => {
    const {commentStringIsInvalid, onCancelClick, onConfirmClick, placeholderText, cancelContentText, cancelAriaLabel, confirmAriaLabel, confirmContentText} = UseCommentInputPanel({onPostCommentClick, commentString, setCommentString, setShowCommentFunctionality});

    if (isPosting) {
        return <div className="posting-comment-loader"><LoadingSpinner size={10} /></div>
    }
    return (
        (showCommentFunctionality &&
            <div className={`comment-input-panel-wrapper ${className ?? ""}`} data-testid="comment-input-panel">
                <CommentTextInput 
                    profilePictureUrl={profileImageUrl} 
                    placeholderText={placeholderText} 
                    commentString={commentString} 
                    setCommentString={setCommentString} 
                />
                
                <CancelConfirmPanel 
                    cancelContent={cancelContentText} 
                    confirmContent={confirmContentText} 
                    ariaLabelCancel={cancelAriaLabel} 
                    ariaLabelConfirm={confirmAriaLabel} 
                    confirmIsDisabled={commentStringIsInvalid} 
                    onCancelClick={onCancelClick} 
                    onConfirmClick={onConfirmClick} />
            </div>
        )
    );
};

export default CommentInputPanel